import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-effluent-watermeter',
  templateUrl: './effluent-watermeter.component.html',
  styleUrls: ['./effluent-watermeter.component.css']
})
export class EffluentWatermeterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
